import { render, staticRenderFns } from "./SimManagement.vue?vue&type=template&id=4387308a&scoped=true&"
import script from "./SimManagement.vue?vue&type=script&lang=js&"
export * from "./SimManagement.vue?vue&type=script&lang=js&"
import style0 from "./SimManagement.vue?vue&type=style&index=0&id=4387308a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387308a",
  null
  
)

export default component.exports